import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["badge"],
  _excluded2 = ["buttonUse", "options", "resetValue"];
import { Select } from 'foundations-components/transitional/components/Select/Select';
import UISelect from 'UIComponents/input/UISelect';
import { useIsUngatedForDisplayOptimizedFormControl } from '../v2/hooks/useIsUngatedForDisplayOptimizedFormControl';
import { createTokenizedComponentWithRef, withoutClassName } from './helpers';
import { jsx as _jsx } from "react/jsx-runtime";
export let _capturedPropsForTesting = {};
const TokenizedUISelect = createTokenizedComponentWithRef(UISelect);
const adaptedButtonUse = buttonUse => {
  if (buttonUse === 'view-group') {
    return undefined;
  }
  return buttonUse;
};
const adaptedOptions = options => {
  if (!options) {
    return options;
  }
  return options.map(option => {
    const {
        badge
      } = option,
      rest = _objectWithoutPropertiesLoose(option, _excluded);
    return Object.assign({}, rest, {
      badge: badge && badge instanceof Object ? badge : undefined
    });
  });
};
export default function SelectAdapter(_ref) {
  let {
      buttonUse,
      options,
      resetValue
    } = _ref,
    commonProps = _objectWithoutPropertiesLoose(_ref, _excluded2);
  const isUngatedForDisplayOptimizedFormControl = useIsUngatedForDisplayOptimizedFormControl();
  if (isUngatedForDisplayOptimizedFormControl) {
    const rest = withoutClassName(commonProps);
    _capturedPropsForTesting = Object.assign({
      buttonUse,
      options,
      resetValue
    }, rest);
    return /*#__PURE__*/_jsx(Select, Object.assign({
      "data-test-id": "Select",
      buttonUse: buttonUse,
      options: options,
      resetValue: resetValue
    }, rest));
  }
  const _buttonUse = adaptedButtonUse(buttonUse);
  const _options = adaptedOptions(options);
  _capturedPropsForTesting = Object.assign({
    buttonUse: _buttonUse,
    options: _options,
    resetValue
  }, commonProps);
  return /*#__PURE__*/_jsx(TokenizedUISelect, Object.assign({
    "data-test-id": "UISelect",
    buttonUse: _buttonUse,
    options: _options,
    resetValue: resetValue || undefined
  }, commonProps));
}